export const REQUIREMENT_DATA = {
  qualifying: {
    name: 'Qualifying',
    requirements: {
      'background_check': {
        name: 'Background Check',
        statuses: {
          'ready': {
            label: 'Ready',
            message: 'To apply as an Associate, please complete a background check through HireRight.',
            primaryLinkText: 'Start Background Check',
            primaryLinkUrl: '#',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'pending': {
            label: 'Pending',
            message: 'Your background check was submitted. Results can take, on average, 2-4 business days.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: 'Your background check was approved!',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'denied': {
            label: 'Denied',
            message: "Unfortunately, your background check did not pass. Please reach out to our team to discuss your options.",
            primaryLinkText: 'Contact Member Services',
            primaryLinkUrl: '#',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'expired': {
            label: 'Expired',
            message: 'To apply as an Associate, please complete a new background check.',
            primaryLinkText: 'Start Background Check',
            primaryLinkUrl: 'https://account.pga.org/background-check',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      },
      'playing_ability_test': {
        name: 'Playing Ability Test (PAT)',
        statuses: {
          'ready': {
            label: 'Ready',
            message: 'Your next step is to qualify for the PAT, you can do so by playing in an event or using an approved alternative.',
            primaryLinkText: 'Find a PAT',
            primaryLinkUrl: 'https://events.pga.org/search?numericFilters%5B0%5D=start_datetime_unix%3E%3D{{unixTimestamp}}&hitsPerPage=10&page=1&refinementList%5Bevent_categories%5D%5B0%5D=Playing%20Ability%20Test&configure%5BaroundRadius%5D=40225&configure%5BaroundLatLngViaIP%5D=true',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: 'Learn More',
            infoLinkUrl: '/membership/associate-program/path-to-membership-articles/playing-ability-test-pat'
          },
          'deferred': {
            label: 'Deferred',
            message: "You've chosen to defer your PAT for now. Register when you're ready.",
            primaryLinkText: 'Find a PAT',
            primaryLinkUrl: 'https://events.pga.org/search?numericFilters%5B0%5D=start_datetime_unix%3E%3D{{unixTimestamp}}&hitsPerPage=10&page=1&refinementList%5Bevent_categories%5D%5B0%5D=Playing%20Ability%20Test&configure%5BaroundRadius%5D=40225&configure%5BaroundLatLngViaIP%5D=true',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'registered': {
            label: 'Registered',
            message: "Your PAT is on Thursday, Sept 25th at 2:00pm EDT.",
            primaryLinkText: 'See Event Details',
            primaryLinkUrl: 'https://events.pga.org/my-events',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'qualified': {
            label: 'Qualified',
            message: "Congratulations, you have qualifying scores and can advance to Level 1. You will still need to pass the PAT in order to enroll as a PGA of America Professional by the end of Level 3.",
            primaryLinkText: 'Find a PAT',
            primaryLinkUrl: 'https://events.pga.org/search?numericFilters%5B0%5D=start_datetime_unix%3E%3D{{unixTimestamp}}&hitsPerPage=10&page=1&refinementList%5Bevent_categories%5D%5B0%5D=Playing%20Ability%20Test&configure%5BaroundRadius%5D=40225&configure%5BaroundLatLngViaIP%5D=true',
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: '/membership/associate-program/path-to-membership-articles/playing-ability-test-pat',
            infoLinkText: 'Learn More',
            infoLinkUrl: '/membership/associate-program/path-to-membership-articles/playing-ability-test-pat'
          },
          'failed': {
            label: 'Failed',
            message: "Unfortunately, your scores aren't passing. Register to try again when you're ready.",
            primaryLinkText: 'Find a PAT',
            primaryLinkUrl: 'https://events.pga.org/search?numericFilters%5B0%5D=start_datetime_unix%3E%3D{{unixTimestamp}}&hitsPerPage=10&page=1&refinementList%5Bevent_categories%5D%5B0%5D=Playing%20Ability%20Test&configure%5BaroundRadius%5D=40225&configure%5BaroundLatLngViaIP%5D=true',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Passed',
            message: 'Major milestone complete: you passed!',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'expired': {
            label: 'Expired',
            message: "Unfortunately, your scores expired. Register to try again when you're ready.",
            primaryLinkText: 'Find a PAT',
            primaryLinkUrl: 'https://events.pga.org/search?numericFilters%5B0%5D=start_datetime_unix%3E%3D{{unixTimestamp}}&hitsPerPage=10&page=1&refinementList%5Bevent_categories%5D%5B0%5D=Playing%20Ability%20Test&configure%5BaroundRadius%5D=40225&configure%5BaroundLatLngViaIP%5D=true',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      },
      'course_manuals': {
        name: 'Course Manuals',
        statuses: {
          'ready': {
            label: 'Ready',
            message: 'Open the Education Portal to view the course manuals and get started.',
            primaryLinkText: 'Start Coursework',
            primaryLinkUrl: 'https://pgaofamerica.instructure.com/',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'in_progress': {
            label: 'In Progress',
            message: 'Open the Education Portal to pick up where you left off.',
            primaryLinkText: 'Resume Coursework',
            primaryLinkUrl: 'https://pgaofamerica.instructure.com/',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: 'Great job, you completed the required coursework.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      },
      'application': {
        name: 'Application',
        statuses: {
          'locked': {
            label: 'Locked',
            message: 'Please complete all requirements in order to purchase Level 1.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'ready': {
            label: 'Ready',
            message: "Congratulations, you're now eligible to purchase Level 1.",
            primaryLinkText: 'Purchase Level 1',
            primaryLinkUrl: '#',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'submitted': {
            label: 'Submitted',
            message: 'Your application has been submitted and is currently being reviewed.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: 'Congratulations, you have completed the Qualifying Level!',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      }
    }
  },
  level1: {
    name: 'Level 1',
    requirements: {
      'course_manuals': {
        name: 'Course Manuals',
        statuses: {
          'locked': {
            label: 'Locked',
            message: 'Complete all Qualifying Requirements to start Level 1.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'ready': {
            label: 'Ready',
            message: 'Open the Education Portal to view the Facility Management 1 course manuals and get started.',
            primaryLinkText: 'Start Coursework',
            primaryLinkUrl: 'https://pgaofamerica.instructure.com/courses/712',
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: '/membership/associate-program/path-to-membership-articles/l1-course-manuals',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'incomplete': {
            label: 'Incomplete',
            message: 'Open the Education Portal to pick up where you left off.',
            primaryLinkText: 'Resume Progress',
            primaryLinkUrl: 'https://pgaofamerica.instructure.com/courses/712',
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: '/membership/associate-program/path-to-membership-articles/l1-course-manuals',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: 'Great job, you completed the required coursework.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      },
      'virtual_seminar': {
        name: 'Virtual Seminar',
        statuses: {
          'locked': {
            label: 'Locked',
            message: 'Complete all Qualifying Requirements to start Level 1.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'ready': {
            label: 'Ready',
            message: 'Find a week-long, virtual seminar to attend.',
            primaryLinkText: 'Register Now',
            primaryLinkUrl: 'https://events.pga.org/search?query=virtual%20seminar%20level%201',
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: '/membership/associate-program/path-to-membership-articles/l1-virtual-seminar',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'registered': {
            label: 'Registered',
            message: 'Prepare for your seminar{{seminarDate}} by reviewing the seminar manuals.',
            primaryLinkText: 'Review Seminar Manuals',
            primaryLinkUrl: '/membership/associate-program/path-to-membership-articles/l1-virtual-seminar',
            secondaryLinkText: 'My Event Calendar',
            secondaryLinkUrl: 'https://events.pga.org/my-events',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'attending': {
            label: 'Attending',
            message: "It's seminar week! Class runs from 8AM CT to approximately 4PM daily. Your virtual conference opens at 7:45AM.",
            primaryLinkText: 'Join Seminar',
            primaryLinkUrl: 'https://pgaofamerica.instructure.com/courses/462/conferences',
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: '/membership/associate-program/path-to-membership-articles/l1-virtual-seminar',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: 'Thank you for participating in the virtual seminar.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      },
      'portfolio': {
        name: 'Portfolio',
        statuses: {
          'locked': {
            label: 'Locked',
            message: 'Complete all Qualifying Requirements to start Level 1.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'ready': {
            label: 'Ready',
            message: 'Build your portfolio by applying the skills and knowledge presented in the courses to your work environment.',
            primaryLinkText: 'Access Portfolio',
            primaryLinkUrl: 'https://pgaofamerica.instructure.com/courses/463/modules',
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: '/membership/associate-program/path-to-membership-articles/l1-portfolio',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: 'Great job! Your Level 1 work experience portfolio has been approved.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      },
      'purchase': {
        name: 'Purchase Level 2',
        statuses: {
          'locked': {
            label: 'Locked',
            message: 'Please complete all requirements in order to purchase Level 2.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'ready': {
            label: 'Ready',
            message: "Congratulations, you're now eligible to purchase Level 2.",
            primaryLinkText: 'Purchase Level 2',
            primaryLinkUrl: 'https://apps.pga.org/professionals/apps/education/pgapgm31/level2reg.cfm?entity_id={{pgaId}}',
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: '/membership/associate-program/path-to-membership-articles/l2-registration',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: "Congratulations, you have completed Level 1!",
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      }
    }
  },
  level2: {
    name: 'Level 2',
    requirements: {
      'course_manuals': {
        name: 'Course Manuals',
        statuses: {
          'locked': {
            label: 'Locked',
            message: 'Complete all Level 1 Requirements to start Level 2.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'ready': {
            label: 'Ready',
            message: 'Open the Education Portal to view the{{courseName}} course manuals and get started.',
            primaryLinkText: 'Start Coursework',
            primaryLinkUrl: 'https://pgaofamerica.instructure.com/courses/502',
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: '/membership/associate-program/path-to-membership-articles/{{careerPathSlug}}l2-course-manuals',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'incomplete': {
            label: 'Incomplete',
            message: 'Open the Education Portal to pick up where you left off.',
            primaryLinkText: 'Resume Progress',
            primaryLinkUrl: 'https://pgaofamerica.instructure.com/courses/502',
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: '/membership/associate-program/path-to-membership-articles/{{careerPathSlug}}l2-course-manuals',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: 'Great job, you completed the required coursework.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      },
      'seminar': {
        name: 'Seminar',
        statuses: {
          'locked': {
            label: 'Locked',
            message: 'Complete all Level 1 Requirements to start Level 2.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'ready': {
            label: 'Ready',
            message: 'Find a week-long seminar in Frisco, TX to attend.',
            primaryLinkText: 'Register Now',
            primaryLinkUrl: 'https://events.pga.org/search?numericFilters%5B0%5D=start_datetime_unix%3E%3D{{unixTimestamp}}&hitsPerPage=10&page=1&refinementList%5Bevent_categories%5D%5B0%5D=Education',
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: '/membership/associate-program/path-to-membership-articles/{{careerPathSlug}}l2-seminar',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'registered': {
            label: 'Registered',
            message: 'Prepare for your seminar in Frisco, TX{{seminarDate}} by reviewing the seminar manuals.',
            primaryLinkText: 'Get Ready',
            primaryLinkUrl: '#',
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: '/membership/associate-program/path-to-membership-articles/{{careerPathSlug}}l2-seminar',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'in_progress': {
            label: 'In Progress',
            message: "It's seminar week! Class is at The Home of the PGA from 8AM CT to approximately 4PM daily.",
            primaryLinkText: 'Directions to PGA HQ',
            primaryLinkUrl: 'https://maps.app.goo.gl/Y24jpQ23PHLdqp5z9',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: 'Thank you for joining us in Frisco, TX.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      },
      'portfolio': {
        name: 'Portfolio',
        statuses: {
          'locked': {
            label: 'Locked',
            message: 'Complete all Level 1 Requirements to start Level 2.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'ready': {
            label: 'Ready',
            message: 'Build your portfolio by applying the skills and knowledge presented in the courses to your work environment.',
            primaryLinkText: 'Access Portfolio',
            primaryLinkUrl: 'https://pgaofamerica.instructure.com/',
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: '/membership/associate-program/path-to-membership-articles/{{careerPathSlug}}l2-portfolio',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: 'Great job! Your Level 2 work experience portfolio has been approved.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      },
      'purchase': {
        name: 'Purchase Level 3',
        statuses: {
          'locked': {
            label: 'Locked',
            message: 'Please complete all requirements in order to purchase Level 3.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'ready': {
            label: 'Ready',
            message: "Congratulations, you're now eligible to purchase Level 3.",
            primaryLinkText: 'Purchase Level 3',
            primaryLinkUrl: 'https://apps.pga.org/professionals/apps/education/pgapgm31/level3reg.cfm?entity_id={{pgaId}}',
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: '/membership/associate-program/path-to-membership-articles/l3-registration',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: "Congratulations, you have completed Level 2!",
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      }
    }
  },
  level3: {
    name: 'Level 3',
    requirements: {
      'course_manuals': {
        name: 'Course Manuals',
        statuses: {
          'locked': {
            label: 'Locked',
            message: 'Complete all Level 2 Requirements to start Level 3.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'ready': {
            label: 'Ready',
            message: 'Open the Education Portal to view the course manuals and get started.',
            primaryLinkText: 'Start Coursework',
            primaryLinkUrl: 'https://pgaofamerica.instructure.com/',
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: '/membership/associate-program/path-to-membership-articles/{{careerPathSlug}}l3-course-manuals',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'incomplete': {
            label: 'Incomplete',
            message: 'Open the Education Portal to pick up where you left off.',
            primaryLinkText: 'Resume Progress',
            primaryLinkUrl: 'https://pgaofamerica.instructure.com/',
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: '/membership/associate-program/path-to-membership-articles/{{careerPathSlug}}l3-course-manuals',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: 'Great job, you completed the required coursework.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      },
      'seminar': {
        name: 'Seminar',
        statuses: {
          'locked': {
            label: 'Locked',
            message: 'Complete all Level 2 Requirements to start Level 3.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'ready': {
            label: 'Ready',
            message: 'Find a week-long seminar in Frisco, TX to attend.',
            primaryLinkText: 'Register Now',
            primaryLinkUrl: 'https://events.pga.org/search?numericFilters%5B0%5D=start_datetime_unix%3E%3D{{unixTimestamp}}&hitsPerPage=10&page=1&refinementList%5Bevent_categories%5D%5B0%5D=Education',
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: '/membership/associate-program/path-to-membership-articles/{{careerPathSlug}}l3-seminar',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'registered': {
            label: 'Registered',
            message: 'Prepare for your seminar in Frisco, TX{{seminarDate}} by reviewing the seminar manuals.',
            primaryLinkText: 'Get Ready',
            primaryLinkUrl: '#',
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: '/membership/associate-program/path-to-membership-articles/{{careerPathSlug}}l3-seminar',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'attending': {
            label: 'Attending',
            message: "It's seminar week! Class is at The Home of the PGA from 8AM CT to approximately 4PM daily.",
            primaryLinkText: 'Directions to PGA HQ',
            primaryLinkUrl: 'https://www.google.com/maps/place/1916+PGA+Pkwy,+Frisco,+TX+75034',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: 'Thank you for joining us in Frisco, TX.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      },
      'portfolio': {
        name: 'Portfolio',
        statuses: {
          'locked': {
            label: 'Locked',
            message: 'Complete all Level 2 Requirements to start Level 3.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'ready': {
            label: 'Ready',
            message: 'Build your portfolio by applying the skills and knowledge presented in the courses to your work environment.',
            primaryLinkText: 'Access Portfolio',
            primaryLinkUrl: 'https://pgaofamerica.instructure.com/',
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: '/membership/associate-program/path-to-membership-articles/{{careerPathSlug}}l3-portfolio',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: 'Great job! Your Level 3 work experience portfolio has been approved.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      },
      'final_exam': {
        name: 'Final Exam',
        statuses: {
          'locked': {
            label: 'Locked',
            message: 'Complete all Level 3 Requirements to become eligible for the Final Exam.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'ready': {
            label: 'Ready',
            message: 'You are now eligible to take your Final Exam!',
            primaryLinkText: 'Take the Exam',
            primaryLinkUrl: '#',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: 'Congratulations, you have completed the final step in your Path to Membership!',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      },
      'enrollment': {
        name: 'PGA Membership Application',
        statuses: {
          'locked': {
            label: 'Locked',
            message: 'Please complete all requirements in order to submit your application for Membership.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'ready': {
            label: 'Ready',
            message: "Congratulations, you're now eligible to apply for Membership.",
            primaryLinkText: 'Apply for Membership',
            primaryLinkUrl: 'https://account.pga.org/applications/membership',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'submitted': {
            label: 'Submitted',
            message: 'Your application has been submitted and is currently being reviewed.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: "Congratulations, you are officially a PGA of America member! Welcome to the family.",
            primaryLinkText: "What's Next",
            primaryLinkUrl: '#',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      }
    }
  }
}

